module.exports = __webpack_public_path__ + "assets/img/2131591934007_.pic_hd.68a7fc37.jpg";